import { render } from "./CustomerGuestList.vue?vue&type=template&id=60a264f1"
import script from "./CustomerGuestList.vue?vue&type=script&lang=js"
export * from "./CustomerGuestList.vue?vue&type=script&lang=js"

import "./CustomerGuestList.vue?vue&type=style&index=0&id=60a264f1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__